import React from 'react'
import content from '../../data/content.json'
import MainLoader from './MainLoader'
import SectionLoader from './SectionLoader';
import BlockLoader from './BlockLoader';
import SnippetLoader from './SnippetLoader';

const Reference = ( { reference, collectionSettings } ) => {
    switch(content[reference].type) {
        case 'section':
            return <SectionLoader item={content[reference]} collectionSettings={collectionSettings}/>;
        case 'block':
            return <BlockLoader item={content[reference]} collectionSettings={collectionSettings}/>;
        case 'snippet':
            return <SnippetLoader item={content[reference]} collectionSettings={collectionSettings}/>;
        default:
            return;
    }
}

export default Reference